import React from 'react';
import BaseGridToolbar, { FilterConfig } from '../../base-ui/Grid/components/BaseGridToolbar';

interface CompanyGridToolbarProps {
    filter: string;
    setFilter: React.Dispatch<React.SetStateAction<string>>;
    owner: string;
    setOwner: React.Dispatch<React.SetStateAction<string>>;
    allData: any[];
    handleRefresh?: () => void;
    onAdd?: () => void;
}

const CompanyGridToolbar: React.FC<CompanyGridToolbarProps> = ({
    filter,
    setFilter,
    owner,
    setOwner,
    allData,
    handleRefresh,
    onAdd
}) => {
    // Filter configurations specific to companies
    const filterConfigs: FilterConfig[] = [
        {
            field: 'owner',
            label: 'Owner',
            extractUnique: (data) => data.map(row => row.owner).filter(Boolean)
        }
    ];

    // Convert individual state to filters object
    const filters = { owner };
    const setFilters = (newFilters: Record<string, string>) => {
        setOwner(newFilters.owner || '');
    };

    return (
        <BaseGridToolbar
            filter={filter}
            setFilter={setFilter}
            filters={filters}
            setFilters={setFilters}
            filterConfigs={filterConfigs}
            allData={allData}
            handleRefresh={handleRefresh}
            onAdd={onAdd}
            addButtonLabel="Add Company"
        />
    );
};

export default CompanyGridToolbar;